import * as React from 'react'
import { AssignmentFlowContainerProps } from './types'
import { $GridCollapseContainer } from './styles'
import { ApplicationActions } from './ApplicationActions'

export const AssignmentFlowContainer: React.FC<AssignmentFlowContainerProps> = ({
  isMobile,
  call,
  selectedAssignment,
  handleSelect,
  handleOpenAssign,
  assignments,
  setLeadAssignment,
  assignmentPartition,
  hasLead,
  handleDownloadClick,
  proposalId,
  documents,
  downloadConsolidated,
  downloadAll,
  onChangeUserVisibility,
  step,
  handleReview,
  handlePartitionChange,
  handleRequestChanges,
  handleOpenChangeApplicant,
  handleDeadline,
  handleOpenInvite,
  handleRevoke,
  applicationId,
}) => {

  return (
    isMobile ?
      null
      :
      <$GridCollapseContainer item xs={4} md={3}>
        <ApplicationActions
          handleReview={handleReview}
          handlePartitionChange={handlePartitionChange}
          handleRequestChanges={handleRequestChanges}
          handleSelect={handleSelect}
          handleDeadline={handleDeadline}
          handleOpenAssign={handleOpenAssign}
          handleOpenChangeApplicant={handleOpenChangeApplicant}
          handleOpenInvite={handleOpenInvite}
          handleRevoke={handleRevoke}
          handleDownloadClick={handleDownloadClick}
          proposalId={proposalId}
          applicationId={applicationId}
          documents={documents || []}
          assignments={assignments}
          selectedAssignment={selectedAssignment}
          step={step}
          call={call}
          hasLead={hasLead}
          setLeadAssignment={setLeadAssignment}
          assignmentPartition={assignmentPartition}
          downloadConsolidated={downloadConsolidated}
          downloadAll={downloadAll}
          onChangeUserVisibility={onChangeUserVisibility}
        />
      </$GridCollapseContainer>
  )
}
